angular.module("app").config(function ($stateProvider, $urlRouterProvider) {
    var userData = document.getUserData && document.getUserData() || false,
        defaultRoute = "";

    if (!!userData) {
        if (userData.permissions.indexOf('viewProviders') !== -1){
            defaultRoute = 'main.providers.list';
        }else if (userData.permissions.indexOf('viewPages') !== -1) {
            defaultRoute = 'main.pages.list.texts';
        } else if (userData.permissions.indexOf('viewPayments') !== -1) {
            defaultRoute = 'main.payments';
        }else if(userData.permissions.indexOf('empty') !== -1) {
            defaultRoute ="main.empty";
        }else {
            defaultRoute = 'main.configs.general';
        }
    } else {
        defaultRoute = 'main.configs.general';
    }

    $urlRouterProvider.otherwise(function ($injector) {
        $injector.invoke(['$state', function ($state) {
            $state.go(defaultRoute);
        }]);
    });

    $stateProvider
        .state('login', {
            url: "/old-login",
            templateUrl: "views/login.html",
            controller: "LoginController",
            ncyBreadcrumb: {
                skip: true
            }
        })
        .state('main', {
            abstract: true,
            url: "/",
            templateUrl: "views/home.html",
            controller: "HomePageController",
            ncyBreadcrumb: {
                skip: true
            }
        })
        .state('main.empty', {
            url: "empty",
            templateUrl: "views/empty/index.html",
            controller: "EmptyPageController",
            ncyBreadcrumb: {
                skip: true
            }
        })
        .state('main.pages', {
            abstract: true,
            url: "pages",
            templateUrl: "views/pages/index.html",
            controller: "PagesPageController",
            stateRef: "pages",
            ncyBreadcrumb: {
                skip: true
            }
        })

        .state('main.pages.edit', {
            url: "/:pageId/edit",
            templateUrl: "views/pages/edit.html",
            controller: "PagesEditPageController",
            params: {showMain: true, hasItems: true},
            stateRef: "pages",
            ncyBreadcrumb: {
                parent: function ($scope) {
                    var suffix = "";
                    switch ($scope.pageData.type) {
                        case 'text':
                            suffix = "texts";
                            break;
                        case 'news':
                            suffix = "news";
                            break;
                        case 'category':
                            suffix = "categories";
                            break;
                        case 'sidebar':
                            suffix = "banners";
                            break;
                        case 'promo':
                            suffix = "promos";
                            break;
                    }
                    return "main.pages.list." + suffix;
                },
                label: 'breadcrumb.pages.edit'
            },
            resolve: {
                preloadedPageData: function ($stateParams, pagesService, errorHandler, pageStatuses, settingsService) {
                    var pageId = $stateParams.pageId,
                        filters = {page_id: pageId, limit: 25, status: pageStatuses[0]};
                    filters = angular.extend({}, filters, settingsService.getFilters());
                    return pagesService.getPageItems(filters).then(
                        function (response) {
                            return angular.copy(response);
                        },
                        function (error) {
                            errorHandler(error.message);
                            return null
                        }
                    )
                },
                preloadedPages: function (pagesService, errorHandler, $stateParams) {
                    var pageId = $stateParams.pageId;
                    return pagesService.getCloserPages({id: pageId}).then(
                        function (response) {
                            return angular.copy(response);
                        },
                        function (error) {
                            errorHandler(error.message);
                            return null
                        }
                    )
                }
            }
        })
        .state('main.pages.editDetailed', {
            url: "/:pageId/edit/detailed",
            templateUrl: "views/pages/edit.html",
            controller: "PagesEditPageController",
            stateRef: "pagesDetailed",
            params: {showMain: false, hasItems: true},
            ncyBreadcrumb: {
                parent: function ($scope) {
                    var suffix = "",
                        type = ($scope.pageData && $scope.pageData.type) ||  ($scope.page && $scope.page.type);
                    switch (type) {
                        case 'text':
                            suffix = "texts";
                            break;
                        case 'news':
                            suffix = "news";
                            break;
                        case 'category':
                            suffix = "categories";
                            break;
                        case 'sidebar':
                            suffix = "banners";
                            break;
                        case 'promo':
                            suffix = "promos";
                            break;
                    }
                    if (!type) {
                        return "";
                    }
                    return "main.pages.list." + suffix;
                },
                label: 'breadcrumb.pages.edit'
            },
            resolve: {
                preloadedPageData: function ($stateParams, pagesService, errorHandler, pageStatuses, settingsService, $rootScope, Utils) {
                    Utils.loadEnvFromStorage();
                    var pageId = $stateParams.pageId,
                        filters = {page_id: pageId, limit: ($rootScope.env['pagination' + pageId] && $rootScope.env['pagination' + pageId].limit) || 25, status: $rootScope.env['status' + pageId] || pageStatuses[0]};
                    filters = angular.extend({}, filters, settingsService.getFilters());
                    !!filters.page_id && (filters.page_id =  pageId);
                    if ($rootScope.env['pagination' + pageId]) {
                        filters.current_page = $rootScope.env['pagination' + pageId].current_page;
                    }
                    return pagesService.getPageItems(filters).then(
                        function (response) {
                            return angular.copy(response);
                        },
                        function (error) {
                            errorHandler(error.message);
                            return null
                        }
                    )
                },
                preloadedPages: function (pagesService, errorHandler, $stateParams) {
                    var pageId = $stateParams.pageId;
                    return pagesService.getCloserPages({id: pageId}).then(
                        function (response) {
                            return angular.copy(response);
                        },
                        function (error) {
                            errorHandler(error.message);
                            return null
                        }
                    )
                },
                parentPageIds: function (pagesService, errorHandler, $stateParams) {
                    var pageId = $stateParams.pageId;
                    return pagesService.getParentIds(pageId).then(
                        function (response) {
                            return angular.copy(response);
                        },
                        function (error) {
                            errorHandler(error.message);
                            return null
                        }
                    )
                }
            }
        })

        .state('main.pages.editItem', {
            url: "/:pageId/edit/detailed/:itemId",
            templateUrl: "views/pages/editItem.html",
            controller: "PagesEditItemPageController",
            stateRef: "pagesDetailed",
            params: {showMain: false, hasItems: true},
            ncyBreadcrumb: {
                parent: function($scope) {
                    var type = $scope.pageData.type || $scope.page.type;
                    switch(type) {
                        case 'news':
                           return  "main.pages.list.news";
                        case 'promo':
                            return 'main.pages.list.promos';
                        default:
                            return "main.pages.editDetailed";
                    }
                },
                label: 'breadcrumb.pages.editItem'
            },
            resolve: {
                preloadedItemData: function (pagesService, $stateParams, errorHandler) {
                    return pagesService.getPageItemById({page_id: $stateParams.pageId, id: $stateParams.itemId}).then(
                        function (response) {
                            if (!!response.page.actualNamesPath) {
                                return pagesService.getByExternalPath(response.page.actualNamesPath, {page_id: $stateParams.pageId}).then(
                                    function (namesResponse) {
                                        if (namesResponse.status === "ok") {
                                            var result = angular.copy(response);
                                            result.names = angular.copy(namesResponse.pageNames);
                                            result.used = namesResponse.used;
                                            result.autocomplete = response.page.autocomplete;


                                            return angular.copy(result)
                                        } else {
                                            return angular.copy(response)
                                        }
                                    },
                                    function () {
                                        return angular.copy(response)
                                    }
                                )
                            }
                            return angular.copy(response)
                        },
                        function (response) {
                            errorHandler(response.message);
                            return null;
                        }
                    )
                },
                parentPageIds: function (pagesService, errorHandler, $stateParams) {
                    var pageId = $stateParams.pageId;
                    return pagesService.getParentIds(pageId).then(
                        function (response) {
                            return angular.copy(response);
                        },
                        function (error) {
                            errorHandler(error.message);
                            return null
                        }
                    )
                },
                countryCodes: function(resourcesService) {
                    return resourcesService.getResource("countryCodes.json").then(function (data) {
                        return angular.copy(data);
                    },function (response) {
                        return [];
                    });
                },
            }
        })
        .state('main.pages.createItem', {
            url: "/:pageId/edit/create/item",
            templateUrl: "views/pages/editItem.html",
            stateRef: "pages",
            controller: "PagesCreateItemPageController",
            ncyBreadcrumb: {
                parent: function($scope) {
                    var type = $scope.pageData.type || $scope.page.type;
                    switch(type) {
                        case 'news':
                            return  "main.pages.list.news";
                        case 'promo':
                            return 'main.pages.list.promos';
                        default:
                            return "main.pages.editDetailed";
                    }
                },
                label: 'breadcrumb.pages.createItem'
            },
            resolve: {
                preloadedPageData: function ($stateParams, pagesService, errorHandler) {
                    var pageId = $stateParams.pageId;
                    return pagesService.getPageItems({page_id: pageId, limit: 25}).then(
                        function (response) {
                            if (!!response.page.actualNamesPath) {
                                return pagesService.getByExternalPath(response.page.actualNamesPath, {page_id: pageId}).then(
                                    function (namesResponse) {
                                        if (namesResponse.status === "ok") {
                                            var result = angular.copy(response);
                                            result.names = angular.copy(namesResponse.pageNames);
                                            result.used = namesResponse.used;
                                            result.autocomplete = response.page.autocomplete;
                                            return angular.copy(result)
                                        } else {
                                            return angular.copy(response)
                                        }

                                    },
                                    function () {
                                        return angular.copy(response)
                                    }
                                )
                            }
                            return angular.copy(response);
                        },
                        function (error) {
                            errorHandler(error.message);
                            return null
                        }
                    )
                },
                parentPageIds: function (pagesService, errorHandler, $stateParams) {
                    var pageId = $stateParams.pageId;
                    return pagesService.getParentIds(pageId).then(
                        function (response) {
                            return angular.copy(response);
                        },
                        function (error) {
                            errorHandler(error.message);
                            return null
                        }
                    )
                },
                countryCodes: function(resourcesService) {
                    return resourcesService.getResource("countryCodes.json").then(function (data) {
                        return angular.copy(data);
                    },function (response) {
                        return [];
                    });
                },
            }
        })
        .state('main.pages.list', {
            url: "/all",
            templateUrl: "views/pages/list.html",
            stateRef: "pages",
            abstract: true,
            ncyBreadcrumb: {
                skip: true
            }
        })
        .state('main.pages.list.banners', {
            url: "/banners",
            templateUrl: "views/pages/templates/banners.html",
            ncyBreadcrumb: {
                label: 'breadcrumb.pages.list.banners'
            },
            stateRef: "pages",
            controller: "PagesListPageController",
            resolve: {
                preloadedPages: function (pagesService, settingsService, errorHandler, pageStatuses, $cookies, $rootScope, Utils) {
                    Utils.loadEnvFromStorage();
                    var settings = settingsService.getSettings(),
                        filters = {
                            lang: $rootScope.env.lang || $cookies.get("preferedLanguage") || settings.skin.defaultLang,
                            limit: ($rootScope.env.pagination && $rootScope.env.pagination.limit) || 25,
                            type: "sidebar",
                            status: $rootScope.env.status || pageStatuses[0]
                        };
                    filters = angular.extend({}, settingsService.getFilters(), filters);
                    if(settingsService.getFilters().status !== undefined){
                        filters.status = settingsService.getFilters().status;
                    }
                    if ($rootScope.env.pagination) {
                        filters.current_page = $rootScope.env.pagination.current_page;
                    }
                    return pagesService.getPages(filters).then(
                        function (response) {
                            return (angular.copy(response) || {});
                        },
                        function (error) {
                            errorHandler(error.message);
                            return null
                        }
                    )
                },
                typeToLoad: function () {
                    return "sidebar"
                },
                preloadedPageNames: function (pagesService, errorHandler, $stateParams, $cookies, settingsService, $rootScope, Utils) {
                    var settings = settingsService.getSettings();
                    Utils.loadEnvFromStorage();
                    return pagesService.getPagesNames({pageType:  "sidebar",lang: $rootScope.env.lang || $cookies.get("preferedLanguage") || settings.skin.defaultLang}).then(
                        function (response) {
                            if (response.status == "ok") {
                                return angular.copy(response);
                            }
                            errorHandler(response.message);
                            return null
                        },
                        function (error) {
                            errorHandler(error.message);
                            return null
                        }
                    )
                }
            }
        })
        .state('main.pages.list.news', {
            url: "/news",
            templateUrl: "views/pages/templates/news.html",
            ncyBreadcrumb: {
                label: 'breadcrumb.pages.list.news'
            },
            stateRef: "pages",
            controller: "PagesListNewsAndPromosController",
            resolve: {
                preloadedPages: function (pagesService, settingsService, errorHandler, pageStatuses, $cookies, $rootScope, Utils) {
                    Utils.loadEnvFromStorage();
                    var settings = settingsService.getSettings(),
                        filters = {
                            lang: $rootScope.env.lang || $cookies.get("preferedLanguage") || settings.skin.defaultLang,
                            limit: ($rootScope.env.pagination && $rootScope.env.pagination.limit) || 25,
                            type: "news",
                            status: $rootScope.env.status || pageStatuses[0]
                        };
                    filters = angular.extend({},  settingsService.getFilters(), filters);
                    if(settingsService.getFilters().status !== undefined){
                        filters.status = settingsService.getFilters().status;
                    }
                    if ($rootScope.env.pagination) {
                        filters.current_page = $rootScope.env.pagination.current_page;
                    }
                    if ($rootScope.env.parentNewsPageId) {
                        filters.page_id = $rootScope.env.parentNewsPageId;
                        delete filters.lang;
                        return pagesService.getPageItems(filters).then(
                            function (response) {
                                return (angular.copy(response) || {});
                            },
                            function (error) {
                                errorHandler(error.message);
                                return null
                            }
                        );
                    }else {
                        return pagesService.getPages(filters).then(
                            function (response) {
                                return (angular.copy(response) || {});
                            },
                            function (error) {
                                errorHandler(error.message);
                                return null
                            }
                        )
                    }

                },
                typeToLoad: function () {
                    return "news"
                }
            }
        })
        .state('main.pages.list.promos', {
            url: "/promo",
            templateUrl: "views/pages/templates/promo.html",
            ncyBreadcrumb: {
                label: 'breadcrumb.pages.list.promos'
            },
            stateRef: "pages",
            controller: "PagesListNewsAndPromosController",
            resolve: {
                preloadedPages: function (pagesService, settingsService, errorHandler, pageStatuses, $cookies, $rootScope, Utils, promoDevice) {
                    Utils.loadEnvFromStorage();
                    var settings = settingsService.getSettings(),
                        filters = {
                            lang:  $rootScope.env.lang ||$cookies.get("preferedLanguage") || settings.skin.defaultLang,
                            limit: ($rootScope.env.pagination && $rootScope.env.pagination.limit) || 25,
                            type: "promo",
                            status: $rootScope.env.status || pageStatuses[0],
                            device: $rootScope.env.device || promoDevice[0].value
                        };
                    filters = angular.extend({}, settingsService.getFilters(), filters);
                    if(settingsService.getFilters().status !== undefined){
                        filters.status = settingsService.getFilters().status;
                    }
                    if ($rootScope.env.pagination) {
                        filters.current_page = $rootScope.env.pagination.current_page;
                    }
                    if ($rootScope.env.parentPromosPageId) {
                        filters.page_id = $rootScope.env.parentPromosPageId;
                        delete filters.lang;
                        return pagesService.getPageItems(filters).then(
                            function (response) {
                                return (angular.copy(response) || {});
                            },
                            function (error) {
                                errorHandler(error.message);
                                return null
                            }
                        );
                    }else {
                        return pagesService.getPages(filters).then(
                            function (response) {
                                return (angular.copy(response) || {});
                            },
                            function (error) {
                                errorHandler(error.message);
                                return null
                            }
                        )
                    }
                },
                typeToLoad: function () {
                    return "promo"
                }
            }
        })
        .state('main.pages.list.backgrounds', {
            url: "/backgrounds",
            templateUrl: "views/pages/templates/backgrounds.html",
            ncyBreadcrumb: {
                label: 'breadcrumb.pages.list.backgrounds'
            },
            stateRef: "pages",
            controller: "PagesListBackgroundController",
            resolve: {
                preloadedPageNames: function ($rootScope, pagesService, settingsService, errorHandler, $cookies, Utils) {
                    Utils.loadEnvFromStorage();
                    var settings = settingsService.getSettings(),
                        filters = {
                            lang: $rootScope.env.lang || $cookies.get("preferedLanguage") || settings.skin.defaultLang,
                            pageType: "backgrounds",
                            page_id: 0
                        };
                    return pagesService.getPagesNames(filters).then(
                        function (response) {
                            return (angular.copy(response) || {});
                        },
                        function (error) {
                            errorHandler(error.message);
                            return null
                        }
                    )
                },
                typeToLoad: function () {
                    return "backgrounds"
                },
                preloadedPages: function ($rootScope, pagesService, settingsService, errorHandler, $cookies, Utils) {
                    Utils.loadEnvFromStorage();
                    var settings = settingsService.getSettings(),
                        filters = {
                            lang: $rootScope.env.lang || $cookies.get("preferedLanguage") || settings.skin.defaultLang,
                            limit: 25,
                            type: "background"
                        };
                    return pagesService.getPages(filters).then(
                        function (response) {
                            return (angular.copy(response.pages) || {});
                        },
                        function (error) {
                            errorHandler(error.message);
                            return null
                        }
                    )
                }
            }
        })
        .state('main.pages.list.texts', {
            url: "/texts",
            templateUrl: "views/pages/templates/texts.html",
            ncyBreadcrumb: {
                label: 'breadcrumb.pages.list.texts'
            },
            stateRef: "pages",
            controller: "PagesListPageController",
            resolve: {
                preloadedPages: function (pagesService, settingsService, errorHandler, pageStatuses, $cookies, $rootScope, Utils) {
                    Utils.loadEnvFromStorage();
                    var settings = settingsService.getSettings(),
                        filters = {
                            lang: $rootScope.env.lang || $cookies.get("preferedLanguage") || settings.skin.defaultLang,
                            limit: ($rootScope.env.pagination && $rootScope.env.pagination.limit) || 25,
                            type: "text",
                            status: $rootScope.env.status || pageStatuses[0]
                        };
                    filters = angular.extend({},  settingsService.getFilters(), filters);
                    if(settingsService.getFilters().status !== undefined){
                        filters.status = settingsService.getFilters().status;
                    }
                    if ($rootScope.env.pagination) {
                        filters.current_page = $rootScope.env.pagination.current_page;
                    }
                    return pagesService.getPages(filters).then(
                        function (response) {
                            return (angular.copy(response) || {});
                        },
                        function (error) {
                            errorHandler(error.message);
                            return null
                        }
                    )
                },
                typeToLoad: function () {
                    return "text"
                },
                preloadedPageNames: function (pagesService, errorHandler, $stateParams, $cookies, settingsService, $rootScope, Utils) {
                    var settings = settingsService.getSettings();
                    Utils.loadEnvFromStorage();
                    return pagesService.getPagesNames({pageType:  "text", lang: $rootScope.env.lang || $cookies.get("preferedLanguage") || settings.skin.defaultLang}).then(
                        function (response) {
                            if (response.status == "ok") {
                                return angular.copy(response);
                            }
                            errorHandler(response.message);
                            return null
                        },
                        function (error) {
                            errorHandler(error.message);
                            return null
                        }
                    )
                }
            }
        })
        .state('main.configs', {
            url: "configs",
            templateUrl: "views/configs/index.html",
            abstract: true,
            ncyBreadcrumb: {
                skip: true
            }
        })
        .state('main.configs.availableConfigs', {
            url: "/availableConfigs",
            templateUrl: "views/configs/availableConfigs.html",
            controller: "AvailableConfigsPageController",
            ncyBreadcrumb: {
                label: 'breadcrumb.configs'
            },
            resolve: {
                preloadedSkinsList: function (skinService, errorHandler, pageStatuses, userStorage) {
                    if (userStorage.getUserData().permissions.indexOf('viewSystemSettings') === -1) {
                        return []
                    }
                    return skinService.getAllSkins({status: pageStatuses[0]}).then(
                        function (response) {
                            if (response && response.status === "ok") {
                                return angular.copy(response.skins);
                            } else {
                                errorHandler((response) ? response.message : "");
                                return {}
                            }
                        },
                        function (response) {
                            errorHandler((response) ? response.message : "");
                            return {}
                        }
                    )
                },
                preloadedConfigs: function (configsService, errorHandler) {
                    return configsService.getConfigsMenu({only_visible_for_skin: 1}).then(
                        function (response) {
                            return (angular.copy(response.configs) || {});
                        },
                        function (error) {
                            errorHandler(error.message);
                            return null
                        }
                    );
                },
                preloadedConfigTypes: function (configsService, errorHandler) {
                    return configsService.getConfigTypes().then(
                        function (response) {
                            return (angular.copy(response.configTypes) || {});
                        },
                        function (error) {
                            errorHandler(error.message);
                            return null
                        }
                    );
                },
                preloadedVersions: function (configsService, errorHandler, userStorage) {
                    if (userStorage.getUserData().permissions.indexOf('viewAvailableSystemSettings') === -1) {
                        return []
                    }
                    return configsService.getVersionsBySkinId(userStorage.getUserData().skin_id).then(
                        function (response) {
                            return (angular.copy(response.versions) || {});
                        },
                        function (error) {
                            errorHandler(error.message);
                            return null
                        }
                    );
                }
            }
        })
        .state('main.configs.availableMobileConfigs', {
            url: "/availableMobileConfigs",
            templateUrl: "views/configs/mobile/availableConfigs.html",
            controller: "MobileAvailableConfigsPageController",
            ncyBreadcrumb: {
                label: 'breadcrumb.mobileConfigs'
            },
            resolve: {
                preloadedSkinsList: function (skinService, errorHandler, pageStatuses, userStorage) {
                    if (userStorage.getUserData().permissions.indexOf('viewMobileSystemSettings') === -1) {
                        return []
                    }
                    return skinService.getAllSkins({status: pageStatuses[0]}).then(
                        function (response) {
                            if (response && response.status === "ok") {
                                return angular.copy(response.skins);
                            } else {
                                errorHandler((response) ? response.message : "");
                                return {}
                            }
                        },
                        function (response) {
                            errorHandler((response) ? response.message : "");
                            return {}
                        }
                    )
                },
                preloadedConfigs: function (mobileConfigsService, errorHandler) {
                    return mobileConfigsService.getConfigsMenu({only_visible_for_skin: 1}).then(
                        function (response) {
                            return (angular.copy(response.configs) || {});
                        },
                        function (error) {
                            errorHandler(error.message);
                            return null
                        }
                    );
                },
                preloadedConfigTypes: function (mobileConfigsService, errorHandler) {
                    return mobileConfigsService.getConfigTypes().then(
                        function (response) {
                            return (angular.copy(response.configTypes) || {});
                        },
                        function (error) {
                            errorHandler(error.message);
                            return null
                        }
                    );
                },
                preloadedVersions: function (mobileConfigsService, errorHandler, userStorage) {
                    if (userStorage.getUserData().permissions.indexOf('viewAvailableSystemSettings') === -1) {
                        return []
                    }
                    return mobileConfigsService.getVersionsBySkinId(userStorage.getUserData().skin_id).then(
                        function (response) {
                            return (angular.copy(response.versions) || {});
                        },
                        function (error) {
                            errorHandler(error.message);
                            return null
                        }
                    );
                }
            }
        })
        .state('main.configs.general', {
            url: "/general",
            templateUrl: "views/configs/configs.html",
            controller: "ConfigurationsPageController",
            ncyBreadcrumb: {
                label: 'breadcrumb.configs'
            },
            resolve: {
                preloadedSkinsList: function (skinService, errorHandler, pageStatuses, userStorage) {
                    if (userStorage.getUserData().permissions.indexOf('viewSystemSettings') === -1) {
                        return []
                    }
                    return skinService.getAllSkins({status: pageStatuses[0]}).then(
                        function (response) {
                            if (response && response.status === "ok") {
                                return angular.copy(response.skins);
                            } else {
                                errorHandler((response) ? response.message : "");
                                return {}
                            }
                        },
                        function (response) {
                            errorHandler((response) ? response.message : "");
                            return {}
                        }
                    )
                },
                preloadedConfigs: function (configsService, errorHandler) {
                    return configsService.getConfigsMenu().then(
                        function (response) {
                            return (angular.copy(response.configs) || {});
                        },
                        function (error) {
                            errorHandler(error.message);
                            return null
                        }
                    );
                },
                preloadedConfigTypes: function (configsService, errorHandler) {
                    return configsService.getConfigTypes().then(
                        function (response) {
                            return (angular.copy(response.configTypes) || {});
                        },
                        function (error) {
                            errorHandler(error.message);
                            return null
                        }
                    );
                },
                preloadedVersions: function (configsService, errorHandler, userStorage) {
                    if (userStorage.getUserData().permissions.indexOf('viewSkinSettings') === -1) {
                        return []
                    }
                    return configsService.getVersionsBySkinId(userStorage.getUserData().skin_id).then(
                        function (response) {
                            return (angular.copy(response.versions) || {});
                        },
                        function (error) {
                            errorHandler(error.message);
                            return null
                        }
                    );
                }
            }
        })
        .state('main.configs.generalMobile', {
            url: "/generalMobile",
            templateUrl: "views/configs/mobile/configs.html",
            controller: "MobileConfigurationsPageController",
            ncyBreadcrumb: {
                label: 'breadcrumb.mobileConfigs'
            },
            resolve: {
                preloadedSkinsList: function (skinService, errorHandler, pageStatuses, userStorage) {
                    if (userStorage.getUserData().permissions.indexOf('viewMobileSystemSettings') === -1) {
                        return []
                    }
                    return skinService.getAllSkins({status: pageStatuses[0]}).then(
                        function (response) {
                            if (response && response.status === "ok") {
                                return angular.copy(response.skins);
                            } else {
                                errorHandler((response) ? response.message : "");
                                return {}
                            }
                        },
                        function (response) {
                            errorHandler((response) ? response.message : "");
                            return {}
                        }
                    )
                },
                preloadedConfigs: function (mobileConfigsService, errorHandler) {
                    return mobileConfigsService.getConfigsMenu().then(
                        function (response) {
                            return (angular.copy(response.configs) || {});
                        },
                        function (error) {
                            errorHandler(error.message);
                            return null
                        }
                    );
                },
                preloadedConfigTypes: function (mobileConfigsService, errorHandler) {
                    return mobileConfigsService.getConfigTypes().then(
                        function (response) {
                            return (angular.copy(response.configTypes) || {});
                        },
                        function (error) {
                            errorHandler(error.message);
                            return null
                        }
                    );
                },
                preloadedVersions: function (mobileConfigsService, errorHandler, userStorage) {
                    if (userStorage.getUserData().permissions.indexOf('viewMobileSkinSettings') === -1) {
                        return []
                    }
                    return mobileConfigsService.getVersionsBySkinId(userStorage.getUserData().skin_id).then(
                        function (response) {
                            return (angular.copy(response.versions) || {});
                        },
                        function (error) {
                            errorHandler(error.message);
                            return null
                        }
                    );
                }
            }
        })
        .state('main.configs.skinConfigs', {
            url: "/individual",
            templateUrl: "views/configs/skinConfigs.html",
            controller: "SkinConfigurationsPageController",
            ncyBreadcrumb: {
                label: 'breadcrumb.configs'
            },
            resolve: {
                preloadedSkinsList: function (skinService, errorHandler, pageStatuses, userStorage, $filter) {
                    if (userStorage.getUserData().permissions.indexOf('viewAvailableSkinSettings') === -1) {
                        return []
                    }
                    return skinService.getAllSkins({status: pageStatuses[0]}).then(
                        function (response) {
                            var orderBy = $filter("orderBy"),
                                result = [];
                            if (response && response.status === "ok") {
                                result = angular.copy(orderBy(response.skins, "id"));
                                result.unshift({name: "Select Skin", id: null});
                                return result;
                            } else {
                                errorHandler((response) ? response.message : "");
                                return {}
                            }
                        },
                        function (response) {
                            errorHandler((response) ? response.message : "");
                            return {}
                        }
                    )
                },
                preloadedConfigs: function (configsService, errorHandler, preloadedSkinsList) {
                    if (!preloadedSkinsList[0].id) {
                        return {};
                    }

                    return configsService.getConfigsMenu({skin_id: preloadedSkinsList[0].id}).then(
                        function (response) {
                            return (angular.copy(response.configs) || {});
                        },
                        function (error) {
                            errorHandler(error.message);
                            return null
                        }
                    );
                },
                preloadedConfigTypes: function (configsService, errorHandler) {
                    return configsService.getConfigTypes().then(
                        function (response) {
                            return (angular.copy(response.configTypes) || {});
                        },
                        function (error) {
                            errorHandler(error.message);
                            return null
                        }
                    );
                },
                preloadedVersions: function (configsService, errorHandler, preloadedSkinsList) {
                    if (!preloadedSkinsList[0].id) {
                        return {}
                    }

                    return configsService.getVersionsBySkinId(preloadedSkinsList[0].id).then(
                        function (response) {
                            return (angular.copy(response.versions) || {});
                        },
                        function (error) {
                            errorHandler(error.message);
                            return null
                        }
                    );
                }
            }
        })
        .state('main.configs.skinMobileConfigs', {
            url: "/individualMobile",
            templateUrl: "views/configs/mobile/skinConfigs.html",
            controller: "MobileSkinConfigurationsPageController",
            ncyBreadcrumb: {
                label: 'breadcrumb.mobileConfigs'
            },
            resolve: {
                preloadedSkinsList: function (skinService, errorHandler, pageStatuses, userStorage, $filter) {
                    if (userStorage.getUserData().permissions.indexOf('viewMobileAvailableSkinSettings') === -1) {
                        return []
                    }
                    return skinService.getAllSkins({status: pageStatuses[0]}).then(
                        function (response) {
                            var orderBy = $filter("orderBy"),
                                result = [];
                            if (response && response.status === "ok") {
                                result = angular.copy(orderBy(response.skins, "id"));
                                result.unshift({name: "Select Skin", id: null});
                                return result;
                            } else {
                                errorHandler((response) ? response.message : "");
                                return {}
                            }
                        },
                        function (response) {
                            errorHandler((response) ? response.message : "");
                            return {}
                        }
                    )
                },
                preloadedConfigs: function (mobileConfigsService, errorHandler, preloadedSkinsList) {
                    if (!preloadedSkinsList[0].id) {
                        return {};
                    }

                    return mobileConfigsService.getConfigsMenu({skin_id: preloadedSkinsList[0].id}).then(
                        function (response) {
                            return (angular.copy(response.configs) || {});
                        },
                        function (error) {
                            errorHandler(error.message);
                            return null
                        }
                    );
                },
                preloadedConfigTypes: function (mobileConfigsService, errorHandler) {
                    return mobileConfigsService.getConfigTypes().then(
                        function (response) {
                            return (angular.copy(response.configTypes) || {});
                        },
                        function (error) {
                            errorHandler(error.message);
                            return null
                        }
                    );
                },
                preloadedVersions: function (mobileConfigsService, errorHandler, preloadedSkinsList) {
                    if (!preloadedSkinsList[0].id) {
                        return {}
                    }

                    return mobileConfigsService.getVersionsBySkinId(preloadedSkinsList[0].id).then(
                        function (response) {
                            return (angular.copy(response.versions) || {});
                        },
                        function (error) {
                            errorHandler(error.message);
                            return null
                        }
                    );
                }
            }
        })
        .state('main.skinPayments', {
            url: "skinPayments",
            templateUrl: "views/payments/skinPayments.html",
            controller: "SkinPaymentsPageController",
            ncyBreadcrumb: {
                skip: 'breadcrumb.payments'
            },
            resolve: {
                preloadedSkinsList: function (skinService, errorHandler, pageStatuses, userStorage, $filter) {
                    return [{skins: [{skin_id: userStorage.getUserData().skin_id}]}];
                },
                preloadedData: function (paymentsService, errorHandler, userStorage) {
                    return paymentsService.getList().then(
                        function (response) {
                            return (angular.copy(response) || {});
                        },
                        function (error) {
                            errorHandler(error.message);
                            return null
                        }
                    );
                }
            }
        })
        .state('main.monitoring', {
            url: "monitoring",
            templateUrl: "views/monitoring/list.html",
            controller: "MonitoringPageController",
            ncyBreadcrumb: {
                skip: 'breadcrumb.monitoring'
            },
            resolve: {
                preloadedSkins: function (monitoringService, errorHandler, userStorage) {
                    return monitoringService.getSkins().then(
                        function (response) {
                            return (angular.copy(response.data) || {});
                        },
                        function (error) {
                            errorHandler(error.message);
                            return null
                        }
                    );
                }
            }
        })
        .state('main.payments', {
            url: "payments",
            templateUrl: "views/payments/payments.html",
            controller: "PaymentsPageController",
            ncyBreadcrumb: {
                skip: 'breadcrumb.payments'
            },
            resolve: {
                preloadedSkinsList: function (skinService, errorHandler, pageStatuses, userStorage, $filter, paymentsService, settingsService) {
                    var settings = settingsService.getSettings();
                    return skinService.getAllSkins({status: pageStatuses[0]}).then(
                        function (response) {
                            var orderBy = $filter("orderBy");
                            if (response && response.status === "ok") {
                                var skinId = (settings.skin && settings.skin.id) ||(response.skins.length > 0 && response.skins[0].id);
                                response.skins = angular.copy(orderBy(response.skins, "id"));
                                return paymentsService.getList({skin_id: skinId}).then(
                                    function (skinResponse) {
                                       response.skin = angular.copy(skinResponse);
                                       response.skinId = skinId;
                                       return response;
                                    },
                                    function (error) {
                                        errorHandler(error.message);
                                        return null
                                    }
                                );
                            } else {
                                errorHandler((response) ? response.message : "");
                                return {}
                            }
                        },
                        function (response) {
                            errorHandler((response) ? response.message : "");
                            return {}
                        }
                    )
                }
            }
        })
        .state('main.styles', {
            url: "styles",
            templateUrl: "views/styles/styles.html",
            controller: "StylesPageController",
            ncyBreadcrumb: {
                label: 'breadcrumb.styles'
            },
            resolve: {
                preloadedStyles: function (stylesService, errorHandler) {
                    return stylesService.getStylesMenu({status: "published"}).then(
                        function (response) {
                            return (angular.copy(response) || {});
                        },
                        function (error) {
                            errorHandler(error.message);
                            return null
                        }
                    );
                },
                preloadedTemplates: function (templatesService, errorHandler) {
                    return templatesService.getTemplates({status: "published"}).then(
                        function (response) {
                            if (response.status == "ok") {
                                return (angular.copy(response.templates) || []);
                            }
                            errorHandler(response.message);
                            return []
                        },
                        function (response) {
                            errorHandler(response.message);
                            return []
                        }
                    );
                }
            }
        })
        .state('main.products', {
            "url": "products",
            abstract: true,
            templateUrl: "views/products/product.html",
            stateRef: "products",
            ncyBreadcrumb: {
                skip: true
            }
        })
        .state('main.products.exchange', {
            "url": "/exchange-shop",
            templateUrl: "views/products/exchange/list.html",
            controller: "ProductsListController",
            stateRef: "products",
            ncyBreadcrumb: {
                label: 'breadcrumb.products.list'
            },
            resolve: {
                preloadedProductsList: function (productsService, settingsService, errorHandler, pageStatuses, $cookies) {
                    var settings = settingsService.getSettings(),
                        filters = {
                            lang: $cookies.get("preferedLanguage") || settings.skin.defaultLang,
                            limit: 25,
                            status: pageStatuses[0]
                        };

                    filters = angular.extend({}, filters, settingsService.getFilters());

                    return productsService.getProducts(filters).then(
                        function (response) {
                            if (response && response.status === "ok") {
                                return angular.copy(response);
                            } else {
                                errorHandler((response) ? response.message : "");
                                return null
                            }
                        },
                        function (response) {
                            errorHandler(response.message);
                            return null
                        }
                    )
                }
            }
        })
        .state('main.products.loyalty', {
            "url": "/loyalty-points",
            templateUrl: "views/products/loyalty/list.html",
            controller: "LoyaltyListController",
            stateRef: "products",
            ncyBreadcrumb: {
                label: 'breadcrumb.loyalty.list'
            },
            resolve: {
                preloadedLevelsList: function (loyaltyService, settingsService, errorHandler, $cookies) {
                    var settings = settingsService.getSettings(),
                       lang =  $cookies.get("preferedLanguage") || settings.skin.defaultLang;


                    return loyaltyService.getLevels(lang).then(
                        function (response) {
                            if (response && response.status === "ok") {
                                return angular.copy(response);
                            } else {
                                errorHandler((response) ? response.message : "");
                                return null
                            }
                        },
                        function (response) {
                            errorHandler(response.message);
                            return null
                        }
                    )
                }
            }
        })
        .state('main.media', {
            "url": "media",
            abstract: true,
            templateUrl: "views/media/media.html",
            stateRef: "media",
            ncyBreadcrumb: {
                skip: true
            }
        })
        .state('main.media.list', {
            "url": "/list",
            templateUrl: "views/media/list.html",
            controller: "MediasListPageController",
            stateRef: "media",
            ncyBreadcrumb: {
                label: 'breadcrumb.media.list'
            },
            resolve: {
                preloadedImages: function (mediaService, errorHandler, pageStatuses) {
                    return mediaService.getImages({limit: 25, status: pageStatuses[0]}).then(
                        function (response) {
                            if (response && response.status === "ok") {
                                return angular.copy(response);
                            } else {
                                errorHandler((response) ? response.message : "");
                                return []
                            }
                        },
                        function (response) {
                            errorHandler(response.message);
                            return []
                        }
                    )
                }
            }
        })
        .state('main.skins', {
            "url": "skins",
            abstract: true,
            stateRef: "skins",
            templateUrl: "views/skins/skins.html",
            ncyBreadcrumb: {
                skip: true
            }
        })
        .state('main.skins.list', {
            "url": "/list",
            templateUrl: "views/skins/list.html",
            controller: "SkinsListPageController",
            stateRef: "skins",
            ncyBreadcrumb: {
                label: 'breadcrumb.skins.list'
            },
            resolve: {
                preloadedSkinsList: function (skinService, errorHandler, settingsService) {
                    var filters = {limit: 25};
                    filters = angular.extend({}, filters, settingsService.getFilters());
                    return skinService.getAllSkinsList(filters).then(
                        function (response) {
                            if (response && response.status === "ok") {
                                return angular.copy(response);
                            } else {
                                errorHandler((response) ? response.message : "");
                                return {}
                            }
                        },
                        function (response) {
                            errorHandler((response) ? response.message : "");
                            return {}
                        }
                    )
                }
            }
        })
        .state('main.popups', {
            "url": "popups",
            abstract: true,
            templateUrl: "views/popups/popups.html",
            stateRef: "popups",
            ncyBreadcrumb: {
                skip: true
            }
        })
        .state('main.popups.list', {
            "url": "/list",
            templateUrl: "views/popups/list.html",
            controller: "PopupsListPageController",
            stateRef: "popups",
            ncyBreadcrumb: {
                label: 'breadcrumb.popups.list'
            },
            resolve: {
                preloadedPopupsList: function (popupsService, errorHandler, pageStatuses, settingsService, $cookies) {
                    var settings = settingsService.getSettings(),
                        filters = {
                            limit: 25,
                            status: pageStatuses[0],
                            lang: $cookies.get("preferedLanguage") || settings.skin.defaultLang
                        };
                    filters = angular.extend({}, filters, settingsService.getFilters());
                    return popupsService.getPopups(filters).then(
                        function (response) {
                            if (response.status == "ok") {
                                return angular.copy(response);
                            }
                            errorHandler(response.message);
                            return {}
                        },
                        function (response) {
                            errorHandler(response.message);
                            return {}
                        }
                    )
                }
            }
        })
        .state('main.reset', {
            url: "reset",
            templateUrl: "views/reset/reset.html",
            controller: "ResetSkinSettingsPageController",
            ncyBreadcrumb: {
                label: 'breadcrumb.skins.reset'
            }
        })
        /*
         * casino_general_admin_states
         * */

        .state('main.providers', {
            abstract: true,
            url: "providers",
            templateUrl: "views/providers/index.html",
            stateRef: "providers",
            ncyBreadcrumb: {
                skip: true
            }
        })
        .state('main.providers.add', {
            url: "/add",
            templateUrl: "views/providers/add.html",
            controller: "ProvidersAddPageController",
            stateRef: "providers",
            ncyBreadcrumb: {
                label: 'breadcrumb.providers.add'
            },
            resolve: {
                preloadedData: function (casinoProviderService, errorHandler) {
                    return casinoProviderService.get().then(
                        function (response) {
                            if (response.status == "ok") {
                                return angular.copy(response);
                            } else {
                                errorHandler(response.message);
                                return {}
                            }
                        },
                        function (response) {
                            errorHandler(response.message);
                            return {}
                        }
                    )
                }
            }
        })
        .state('main.providers.list', {
            url: "/all",
            templateUrl: "views/providers/list.html",
            controller: "ProvidersListPageController",
            ncyBreadcrumb: {
                label: 'breadcrumb.providers.list'
            },
            stateRef: "providers",
            resolve: {
                preloadedData: function (casinoProviderService, pageStatuses, errorHandler, settingsService) {
                    var filters = {
                        status: pageStatuses[0],
                        limit: 25,
                        current_page: 1
                    };
                    filters = angular.extend({}, filters, settingsService.getFilters());
                    return casinoProviderService.getProviders(filters).then(
                        function (response) {
                            if (response.status === "ok") {
                                return angular.copy(response);
                            } else {
                                errorHandler(response.message);
                                return {}
                            }
                        },
                        function (response) {
                            errorHandler(response.message);
                            return {}
                        }
                    )
                },
                preloadedProviders: function (casinoProviderService, pageStatuses, errorHandler) {
                    return casinoProviderService.getProviders({
                        status: pageStatuses[0]
                    }).then(
                        function (response) {
                            if (response.status === "ok") {
                                return angular.copy(response.providers)
                            } else {
                                errorHandler(response.message);
                                return {}
                            }
                        },
                        function (response) {
                            errorHandler(response.message);
                            return {}
                        }
                    )
                }
            }
        })
        .state('main.categories', {
            "url": "categories",
            abstract: true,
            templateUrl: "views/filters/index.html",
            stateRef: "categories",
            ncyBreadcrumb: {
                skip: true
            }
        })
       .state('main.categories.list', {
            url: "/list",
            templateUrl: "views/filters/templates/categories.html",
            ncyBreadcrumb: {
                label: 'breadcrumb.categories.list'
            },
            stateRef: "categories",
            controller: "FilterPageController",
            resolve: {
                preloadedData: function (casinoCategoryService, $stateParams, errorHandler, pageStatuses, settingsService) {
                    var filters = {
                        type: 'category',
                        status: pageStatuses[0],
                        limit: 25,
                        current_page: 1
                    };

                    filters = angular.extend({}, filters, settingsService.getFilters());
                    return casinoCategoryService.getCategories(filters).then(
                        function (response) {
                            if (response.status === "ok") {
                                return angular.copy(response);
                            } else {
                                errorHandler(response.message);
                                return {}
                            }
                        },
                        function (response) {
                            errorHandler(response.message);
                            return {}
                        }
                    )
                }
            }
        }).state('main.themes', {
            "url": "themes",
            abstract: true,
            templateUrl: "views/filters/index.html",
            stateRef: "themes",
            ncyBreadcrumb: {
                skip: true
            }
        }).state('main.themes.list', {
            url: "/list",
            templateUrl: "views/filters/templates/themes.html",
            ncyBreadcrumb: {
                label: 'breadcrumb.themes.list'
            },
            stateRef: "themes",
            controller: "FilterPageController",
            resolve: {
                preloadedData: function (casinoCategoryService, $stateParams, errorHandler, pageStatuses, settingsService) {
                    var filters = {
                        type: 'theme',
                        status: pageStatuses[0],
                        limit: 25,
                        current_page: 1
                    };

                    filters = angular.extend({}, filters, settingsService.getFilters());
                    return casinoCategoryService.getCategories(filters).then(
                        function (response) {
                            if (response.status === "ok") {
                                return angular.copy(response);
                            } else {
                                errorHandler(response.message);
                                return {}
                            }
                        },
                        function (response) {
                            errorHandler(response.message);
                            return {}
                        }
                    )
                }
            }
        }).state('main.features', {
            "url": "features",
            abstract: true,
            templateUrl: "views/filters/index.html",
            stateRef: "features",
            ncyBreadcrumb: {
                skip: true
            }
        })
        .state('main.features.list', {
            url: "/list",
            templateUrl: "views/filters/templates/features.html",
            ncyBreadcrumb: {
                label: 'breadcrumb.features.list'
            },
            stateRef: "features",
            controller: "FilterPageController",
            resolve: {
                preloadedData: function (casinoCategoryService, $stateParams, errorHandler, pageStatuses, settingsService) {
                    var filters = {
                        type: 'feature',
                        status: pageStatuses[0],
                        limit: 25,
                        current_page: 1
                    };

                    filters = angular.extend({}, filters, settingsService.getFilters());
                    return casinoCategoryService.getCategories(filters).then(
                        function (response) {
                            if (response.status === "ok") {
                                return angular.copy(response);
                            } else {
                                errorHandler(response.message);
                                return {}
                            }
                        },
                        function (response) {
                            errorHandler(response.message);
                            return {}
                        }
                    )
                }
            }
        })
        .state('main.games', {
            abstract: true,
            url: "games",
            templateUrl: "views/games/index.html",
            stateRef: "games",
            ncyBreadcrumb: {
                skip: true
            }
        })
        .state('main.games.add', {
            url: "/add",
            templateUrl: "views/games/add.html",
            controller: "GamesAddPageController",
            stateRef: "games",
            ncyBreadcrumb: {
                label: 'breadcrumb.games.add'
            },
            resolve: {
                preloadedCategories: function (casinoCategoryService, pageStatuses, errorHandler) {
                    return casinoCategoryService.get({status: pageStatuses[0], parent_name: "AllCategories"}).then(
                        function (response) {
                            if (response.status === "ok") {
                                return angular.copy(response.categories)
                            } else {
                                errorHandler(response.message);
                                return {}
                            }
                        },
                        function (response) {
                            errorHandler(response.message);
                            return {}
                        }
                    )
                },
                preloadedProviders: function (casinoProviderService, pageStatuses, errorHandler) {
                    return casinoProviderService.get({status: pageStatuses[0]}).then(
                        function (response) {
                            if (response.status === "ok") {
                                return angular.copy(response.providers)
                            } else {
                                errorHandler(response.message);
                                return {}
                            }
                        },
                        function (response) {
                            errorHandler(response.message);
                            return {}
                        }
                    )
                }
            }
        })
        .state('main.games.edit', {
            url: "/:gameId/edit",
            templateUrl: "views/games/edit.html",
            stateRef: "games",
            controller: "GamesEditPageController",
            ncyBreadcrumb: {
                parent: "main.games.list",
                label: 'breadcrumb.games.edit'
            },
            resolve: {
                preloadedGameData: function (casinoGameService, $stateParams, errorHandler) {
                    return casinoGameService.get({id: $stateParams.gameId}).then(
                        function (response) {
                            if (response.status === "ok") {
                                return angular.copy(response.game)
                            } else {
                                errorHandler(response.message);
                                return {}
                            }
                        },
                        function (response) {
                            errorHandler(response.message);
                            return {}
                        }
                    )
                },
                preloadedCategories: function (casinoCategoryService, pageStatuses, errorHandler) {
                    return casinoCategoryService.get({status: pageStatuses[0], parent_name: "AllCategories"}).then(
                        function (response) {
                            if (response.status === "ok") {
                                return angular.copy(response.categories)
                            } else {
                                errorHandler(response.message);
                                return {}
                            }
                        },
                        function (response) {
                            errorHandler(response.message);
                            return {}
                        }
                    )
                },
                preloadedProviders: function (casinoProviderService, pageStatuses, errorHandler) {
                    return casinoProviderService.get({status: pageStatuses[0]}).then(
                        function (response) {
                            if (response.status === "ok") {
                                return angular.copy(response.providers)
                            } else {
                                errorHandler(response.message);
                                return {}
                            }
                        },
                        function (response) {
                            errorHandler(response.message);
                            return {}
                        }
                    )
                }
            }
        })
        .state('main.games.list', {
            url: "/all",
            templateUrl: "views/games/list.html",
            stateRef: "games",
            controller: "GamesListPageController",
            ncyBreadcrumb: {
                label: 'breadcrumb.games.list'
            },
            resolve: {
                preloadedData: function (casinoGameService, pageStatuses, errorHandler, settingsService) {
                    var filters = {status: pageStatuses[0], limit: 25};
                    filters = angular.extend({}, filters, settingsService.getFilters());
                    return casinoGameService.get(filters).then(
                        function (response) {
                            if (response.status === "ok") {
                                return angular.copy(response)
                            } else {
                                errorHandler(response.message);
                                return {}
                            }
                        },
                        function (response) {
                            errorHandler(response.message);
                            return {}
                        }
                    )
                },
                preloadedCategories: function (casinoCategoryService, pageStatuses, errorHandler) {
                    return casinoCategoryService.get({status: pageStatuses[0], type: "category", is_custom: 0}).then(
                        function (response) {
                            if (response.status === "ok") {
                                return angular.copy(response.categories)
                            } else {
                                errorHandler(response.message);
                                return {}
                            }
                        },
                        function (response) {
                            errorHandler(response.message);
                            return {}
                        }
                    )
                },
                preloadedFeatures: function (casinoCategoryService, pageStatuses, errorHandler) {
                    return casinoCategoryService.get({status: pageStatuses[0], type: "feature"}).then(
                        function (response) {
                            if (response.status === "ok") {
                                return angular.copy(response.categories)
                            } else {
                                errorHandler(response.message);
                                return {}
                            }
                        },
                        function (response) {
                            errorHandler(response.message);
                            return {}
                        }
                    )
                },
                preloadedThemes: function (casinoCategoryService, pageStatuses, errorHandler) {
                    return casinoCategoryService.get({status: pageStatuses[0], type: "theme"}).then(
                        function (response) {
                            if (response.status === "ok") {
                                return angular.copy(response.categories)
                            } else {
                                errorHandler(response.message);
                                return {}
                            }
                        },
                        function (response) {
                            errorHandler(response.message);
                            return {}
                        }
                    )
                },
                preloadedProviders: function (casinoProviderService, pageStatuses, errorHandler) {
                    return casinoProviderService.get({status: pageStatuses[0]}).then(
                        function (response) {
                            if (response.status === "ok") {
                                return angular.copy(response.providers)
                            } else {
                                errorHandler(response.message);
                                return {}
                            }
                        },
                        function (response) {
                            errorHandler(response.message);
                            return {}
                        }
                    )
                }
            }
        })
        .state('main.games.join', {
            url: "/join",
            templateUrl: "views/games/join.html",
            stateRef: "games",
            controller: "GamesJoinPageController",
            ncyBreadcrumb: {
                label: 'breadcrumb.games.join'
            },
            resolve: {
                preloadedSkinsList: function (skinService, errorHandler, pageStatuses) {
                    return skinService.getAllSkins({status: pageStatuses[0]}).then(
                        function (response) {
                            if (response && response.status === "ok") {
                                return angular.copy(response.skins);
                            } else {
                                errorHandler((response) ? response.message : "");
                                return {}
                            }
                        },
                        function (response) {
                            errorHandler((response) ? response.message : "");
                            return {}
                        }
                    )
                },
                preloadedProvidersAndGames: function (casinoGameService, pageStatuses, errorHandler) {
                    return casinoGameService.getProvidersGroups({status: pageStatuses[0]}).then(
                        function (response) {
                            if (response.status === "ok") {
                                return angular.copy(response.groups)
                            } else {
                                errorHandler(response.message);
                                return {}
                            }
                        },
                        function (response) {
                            errorHandler(response.message);
                            return {}
                        }
                    )
                },
                preloadedSkins: function (casinoGameService, errorHandler) {
                    return casinoGameService.getSkins().then(
                        function (response) {
                            if (response.status == "ok") {
                                return angular.copy(response.skins);
                            } else {
                                errorHandler(response.message);
                                return {}
                            }
                        },
                        function (response) {
                            errorHandler(response.message);
                            return {}
                        }
                    )
                },
                preloadedCategories: function (casinoCategoryService, pageStatuses, errorHandler) {
                    return casinoCategoryService.get({status: pageStatuses[0], type: "category"}).then(
                        function (response) {
                            if (response.status === "ok") {
                                return angular.copy(response.categories)
                            } else {
                                errorHandler(response.message);
                                return {}
                            }
                        },
                        function (response) {
                            errorHandler(response.message);
                            return {}
                        }
                    )
                },
                preloadedProviders: function (casinoProviderService, pageStatuses, errorHandler) {
                    return casinoProviderService.get({status: pageStatuses[0]}).then(
                        function (response) {
                            if (response.status === "ok") {
                                return angular.copy(response.providers)
                            } else {
                                errorHandler(response.message);
                                return {}
                            }
                        },
                        function (response) {
                            errorHandler(response.message);
                            return {}
                        }
                    )
                }
            }
        })
        .state('main.games.gamesreference', {
            url: "/gamesreference",
            templateUrl: "views/games/gamesreference.html",
            stateRef: "games",
            controller: "GamesReferencePageController",
            ncyBreadcrumb: {
                label: 'breadcrumb.games.gamesreference'
            },
            resolve: {
                preloadedSkins: function (skinService, errorHandler) {
                    return skinService.getAllSkins().then(
                        function (response) {
                            if (response && response.status === "ok") {
                                return angular.copy(response.skins);
                            } else {
                                errorHandler((response) ? response.message : "");
                                return {}
                            }
                        },
                        function (response) {
                            errorHandler((response) ? response.message : "");
                            return {}
                        }
                    )
                },
                preloadedCasinoSkins: function (casinoGameService, errorHandler) {
                    return casinoGameService.getSkins().then(
                        function (response) {
                            if (response && response.status === "ok") {
                                return angular.copy(response.skins);
                            } else {
                                errorHandler((response) ? response.message : "");
                                return {}
                            }
                        },
                        function (response) {
                            errorHandler((response) ? response.message : "");
                            return {}
                        }
                    )
                }
            }
        })
        .state('main.games.categoriesAndProviders', {
            url: "/categoriesAndProviders",
            templateUrl: "views/games/categoriesAndProviders.html",
            stateRef: "games",
            controller: "GamesCategoriesAndProvidersPageController",
            ncyBreadcrumb: {
                label: 'breadcrumb.games.categoriesAndProviders'
            },
            resolve: {
                preloadedSkins: function (casinoGameService, errorHandler) {
                    return casinoGameService.getSkins().then(
                        function (response) {
                            if (response && response.status === "ok") {
                                return angular.copy(response.skins);
                            } else {
                                errorHandler((response) ? response.message : "");
                                return {}
                            }
                        },
                        function (response) {
                            errorHandler((response) ? response.message : "");
                            return {}
                        }
                    )
                }
            }
        })
        .state('main.games.casinoJackpotBanners', {
            url: "/casinoJackpotBanners",
            templateUrl: "views/games/casinoJackpotBanners.html",
            stateRef: "games",
            controller: "GamesCasinoJackpotBannersController",
            ncyBreadcrumb: {
                label: 'breadcrumb.games.casinoJackpotBanners'
            },
            resolve: {
                preloadedPageNames: function ($rootScope, pagesService, settingsService, errorHandler, $cookies, Utils) {
                    Utils.loadEnvFromStorage();
                    var settings = settingsService.getSettings(),
                        filters = {
                            lang: $rootScope.env.lang || $cookies.get("preferedLanguage") || settings.skin.defaultLang,
                            pageType: "live-casino-jackpots",
                            page_id: 0
                        };
                    return pagesService.getPagesNames(filters).then(
                        function (response) {
                            return (angular.copy(response) || {});
                        },
                        function (error) {
                            errorHandler(error.message);
                            return null
                        }
                    )
                },
                preloadedPages: function ($rootScope, pagesService, settingsService, errorHandler, $cookies, Utils) {
                    Utils.loadEnvFromStorage();
                    var settings = settingsService.getSettings(),
                        filters = {
                            lang: $rootScope.env.lang || $cookies.get("preferedLanguage") || settings.skin.defaultLang,
                            limit: 25,
                            type: "live-casino-jackpots"
                        };
                    return pagesService.getPages(filters).then(
                        function (response) {
                            return (angular.copy(response.pages) || {});
                        },
                        function (error) {
                            errorHandler(error.message);
                            return null
                        }
                    )
                }
            }
        })
        .state('main.report', {
            abstract: true,
            url: "report",
            templateUrl: "views/report/index.html",
            stateRef: "report",
            ncyBreadcrumb: {
                skip: true
            }
        })
        .state('main.report.skinsAndProviders', {
            url: "/skinsAndProviders",
            templateUrl: "views/report/skinsAndProviders.html",
            stateRef: "report",
            controller: "SkinsAndProvidersPageController",
            ncyBreadcrumb: {
                label: 'breadcrumb.report.skinsAndProviders'
            },
            resolve: {
                preloadedSkins: function (casinoGameService, errorHandler) {
                    return casinoGameService.getSkins().then(
                        function (response) {
                            if (response && response.status === "ok") {
                                return angular.copy(response.skins);
                            } else {
                                errorHandler((response) ? response.message : "");
                                return {}
                            }
                        },
                        function (response) {
                            errorHandler((response) ? response.message : "");
                            return {}
                        }
                    )
                },
                preloadedProviders: function (casinoProviderService, pageStatuses, errorHandler) {
                    return casinoProviderService.get({status: pageStatuses[0]}).then(
                        function (response) {
                            if (response.status === "ok") {
                                var list = [
                                    {name: "Select provider", id: null}
                                ];

                                angular.forEach(response.providers, function(item, key) {
                                    this.push({
                                        id: item.name,
                                        name: item.title + ' (' + item.name + ')'
                                    });
                                }, list);

                                return list;
                            } else {
                                errorHandler(response.message);
                                return {}
                            }
                        },
                        function (response) {
                            errorHandler(response.message);
                            return {}
                        }
                    )
                }
            }
        })
        .state('main.report.games', {
            url: "/games",
            templateUrl: "views/report/games.html",
            stateRef: "report",
            controller: "GamesPageController",
            ncyBreadcrumb: {
                label: 'breadcrumb.report.games'
            },
            resolve: {
                preloadedCategories: function (casinoCategoryService, pageStatuses, errorHandler) {
                    return casinoCategoryService.get({status: pageStatuses[0], type: "category", is_custom: 0}).then(
                        function (response) {
                            if (response.status === "ok") {
                                var list = [
                                    {name: "Select category", id: null}
                                ];

                                angular.forEach(response.categories, function(item, key) {
                                    this.push({
                                        id: item.id,
                                        name: item.title
                                    });
                                }, list);

                                return list;
                                //return angular.copy(response.categories)
                            } else {
                                errorHandler(response.message);
                                return {}
                            }
                        },
                        function (response) {
                            errorHandler(response.message);
                            return {}
                        }
                    )
                },
                preloadedProviders: function (casinoProviderService, pageStatuses, errorHandler) {
                    return casinoProviderService.get({status: pageStatuses[0]}).then(
                        function (response) {
                            if (response.status === "ok") {
                                var list = [
                                    {name: "Select provider", id: null}
                                ];

                                angular.forEach(response.providers, function(item, key) {
                                    this.push({
                                        id: item.name,
                                        name: item.title + ' (' + item.name + ')'
                                    });
                                }, list);

                                return list;
                            } else {
                                errorHandler(response.message);
                                return {}
                            }
                        },
                        function (response) {
                            errorHandler(response.message);
                            return {}
                        }
                    )
                },
                preloadedFeatures: function (casinoCategoryService, pageStatuses, errorHandler) {
                    return casinoCategoryService.get({status: pageStatuses[0], type: "feature", is_custom: 0}).then(
                        function (response) {
                            if (response.status === "ok") {
                                var list = [
                                    {name: "Select feature", id: null}
                                ];

                                angular.forEach(response.categories, function(item, key) {
                                    this.push({
                                        id: item.id,
                                        name: item.title
                                    });
                                }, list);

                                return list;
                                //return angular.copy(response.categories)
                            } else {
                                errorHandler(response.message);
                                return {}
                            }
                        },
                        function (response) {
                            errorHandler(response.message);
                            return {}
                        }
                    )
                },
            }
        })
        .state('main.skinGames', {
            abstract: true,
            url: "games/skin-games",
            stateRef: "skinGames",
            templateUrl: "views/skinGames/index.html",
            ncyBreadcrumb: {
                skip: true
            }
        })
        .state('main.skinGames.edit', {
            url: "/:gameId/edit",
            templateUrl: "views/skinGames/edit.html",
            controller: "SkinGamesEditPageController",
            stateRef: "skinGames",
            ncyBreadcrumb: {
                parent: "main.skinGames.list",
                label: 'breadcrumb.skinGames.edit'
            },
            resolve: {
                preloadedGameData: function (casinoGameService, $stateParams, errorHandler) {
                    return casinoGameService.getSkinGames({gameSkinId: $stateParams.gameId}).then(
                        function (response) {
                            if (response.status === "ok") {
                                return angular.copy(response.skinGame)
                            } else {
                                errorHandler(response.message);
                                return {}
                            }
                        },
                        function (response) {
                            errorHandler(response.message);
                            return {}
                        }
                    )
                },
                preloadedCategories: function (casinoCategoryService, pageStatuses, errorHandler) {
                    return casinoCategoryService.get({status: pageStatuses[0], parent_name: "AllCategories"}).then(
                        function (response) {
                            if (response.status === "ok") {
                                return angular.copy(response.categories)
                            } else {
                                errorHandler(response.message);
                                return {}
                            }
                        },
                        function (response) {
                            errorHandler(response.message);
                            return {}
                        }
                    )
                },
                preloadedProviders: function (casinoProviderService, pageStatuses, errorHandler) {
                    return casinoProviderService.get({status: pageStatuses[0]}).then(
                        function (response) {
                            if (response.status === "ok") {
                                return angular.copy(response.providers)
                            } else {
                                errorHandler(response.message);
                                return {}
                            }
                        },
                        function (response) {
                            errorHandler(response.message);
                            return {}
                        }
                    )
                }
            }
        })
        .state('main.skinGames.list', {
            url: "/all",
            templateUrl: "views/skinGames/list.html",
            controller: "SkinGamesListPageController",
            stateRef: "skinGames",
            ncyBreadcrumb: {
                label: 'breadcrumb.skinGames.list'
            },
            resolve: {
                preloadedSkins: function (casinoGameService, errorHandler, settingsService) {
                    var filters = angular.extend({}, settingsService.getFilters());
                    return casinoGameService.getSkins(filters).then(
                        function (response) {
                            if (response.status == "ok") {
                                return angular.copy(response.skins);
                            } else {
                                errorHandler(response.message);
                                return {}
                            }
                        },
                        function (response) {
                            errorHandler(response.message);
                            return {}
                        }
                    )
                },
                preloadedProviders: function (casinoProviderService, pageStatuses, errorHandler) {
                    return casinoProviderService.get({status: pageStatuses[0]}).then(
                        function (response) {
                            if (response.status === "ok") {
                                return angular.copy(response.providers)
                            } else {
                                errorHandler(response.message);
                                return {}
                            }
                        },
                        function (response) {
                            errorHandler(response.message);
                            return {}
                        }
                    )
                }
            }
        })
        .state('main.gameReleases', {
            url: "releases",
            stateRef: "gameReleases",
            templateUrl: "views/gameReleases/index.html",
            ncyBreadcrumb: {
                skip: true
            }
        })
        .state('main.gameReleases.list', {
            url: "/all",
            controller: "GameReleasePageController",
            stateRef: "gameReleases",
            templateUrl: "views/gameReleases/list.html",
            ncyBreadcrumb: {
                label: 'breadcrumb.gameReleases.list'
            },
            resolve: {
                preloadedData: function (casinoJobService, releaseJobStatuses, errorHandler, settingsService) {
                    var filters = angular.extend({
                        current_page: 1,
                        limit: 25,
                        status: [20],
                    }, settingsService.getFilters());

                    return casinoJobService.getJobReleaseList(filters).then(
                        function (response) {
                            if (response.status === "ok") {
                                return angular.copy(response);
                            } else {
                                errorHandler(response.message);
                                return {}
                            }
                        },
                        function (response) {
                            errorHandler(response.message);
                            return {}
                        }
                    )
                }
            }
        })
        .state('main.casinoSettings', {
            url: "casino-settings",
            controller: "CasinoSettingsPageController",
            stateRef: "casinoSettings",
            templateUrl: "views/casinoSettings/index.html",
            ncyBreadcrumb: {
                label: 'breadcrumb.casinoSettings'
            },
            resolve: {
                skinCasinoSetting: function (casinoSettingService, errorHandler) {
                    return casinoSettingService.getCasinoSettings().then(
                        function (response) {
                            if (response.status === "ok") {
                                return angular.copy(response.skinCasinoSetting);
                            }
                            return null
                        },
                        function (response) {
                            errorHandler(response.message);
                            return null
                        }
                    )
                }
            }
        })
        .state('main.games.switchSkins', {
            url: "/:gameId/switchSkins",
            stateRef: "games",
            templateUrl: "views/games/switchSkins.html",
            controller: "GamesSwitchSkinsPageController",
            ncyBreadcrumb: {
                parent: "main.games.list",
                label: 'breadcrumb.games.switchSkins'
            },
            resolve: {
                preloadedGameData: function (casinoGameService, $stateParams, errorHandler) {
                    return casinoGameService.get({id: $stateParams.gameId, withSkins: true}).then(
                        function (response) {
                            if (response.status === "ok") {
                                return angular.copy(response.game)
                            } else {
                                errorHandler(response.message);
                                return {}
                            }
                        },
                        function (response) {
                            errorHandler(response.message);
                            return {}
                        }
                    )
                },
                preloadedSkinsList: function (skinService, errorHandler, pageStatuses) {
                    return skinService.getAllSkins({status: pageStatuses[0]}).then(
                        function (response) {
                            if (response && response.status === "ok") {
                                return angular.copy(response);
                            } else {
                                errorHandler((response) ? response.message : "");
                                return {}
                            }
                        },
                        function (response) {
                            errorHandler((response) ? response.message : "");
                            return {}
                        }
                    )
                }
            }
        })
        .state('main.casinoGames', {
            abstract: true,
            url: "casinoGames",
            stateRef: "casinoGames",
            templateUrl: "views/casinoGames/index.html",
            ncyBreadcrumb: {
                skip: true
            }
        })
        .state('main.casinoGames.list', {
            url: "/all",
            templateUrl: "views/casinoGames/list.html",
            controller: "CasinoGamesListPageController",
            stateRef: "casinoGames",
            ncyBreadcrumb: {
                label: 'breadcrumb.casinoGames.list'
            },
            resolve: {
                preloadedData: function (casinoGameService, pageStatuses, errorHandler, settingsService) {
                    var filters = {active: true, limit: 25};
                    filters = angular.extend({}, filters, settingsService.getFilters());
                    return casinoGameService.getSkinGames(filters).then(
                        function (response) {
                            if (response.status === "ok") {
                                return angular.copy(response)
                            } else {
                                errorHandler(response.message);
                                return {}
                            }
                        },
                        function (response) {
                            errorHandler(response.message);
                            return {}
                        }
                    )
                },
                preloadedCategories: function (casinoCategoryService, pageStatuses, errorHandler) {
                    return casinoCategoryService.get({status: pageStatuses[0], type: "category", 'skin_id': 'me'}).then(
                        function (response) {
                            if (response.status === "ok") {
                                return angular.copy(response.categories)
                            } else {
                                errorHandler(response.message);
                                return {}
                            }
                        },
                        function (response) {
                            errorHandler(response.message);
                            return {}
                        }
                    )
                },
                preloadedProviders: function (casinoProviderService, pageStatuses, errorHandler) {
                    return casinoProviderService.get({status: pageStatuses[0]}).then(
                        function (response) {
                            if (response.status === "ok") {
                                return angular.copy(response.providers)
                            } else {
                                errorHandler(response.message);
                                return {}
                            }
                        },
                        function (response) {
                            errorHandler(response.message);
                            return {}
                        }
                    )
                },
                unapprovedGamesCount: function (casinoGameService, errorHandler) {
                    return casinoGameService.getUnapprovedGamesCount({}).then(
                        function (response) {
                            if (response.status === "ok") {
                                return response.count;
                            } else {
                                errorHandler(response.message);
                                return {}
                            }
                        },
                        function (response) {
                            errorHandler(response.message);
                            return {}
                        }
                    )
                }
            }
        })
        .state('main.casinoGames.edit', {
            url: "/:gameId/edit",
            templateUrl: "views/casinoGames/edit.html",
            controller: "CasinoGamesEditPageController",
            stateRef: "casinoGames",
            ncyBreadcrumb: {
                parent: "main.casinoGames.list",
                label: 'breadcrumb.casinoGames.edit'
            },
            resolve: {
                preloadedGameData: function (casinoGameService, $stateParams, errorHandler) {
                    return casinoGameService.getSkinGames({gameSkinId: $stateParams.gameId}).then(
                        function (response) {
                            if (response.status === "ok") {
                                return angular.copy({
                                    id: response.skinGame.gameSkinId,
                                    active: response.skinGame.active,
                                    name: response.skinGame.name,
                                    description: response.skinGame.description,
                                    categories: response.skinGame.categories,
                                })
                            } else {
                                errorHandler(response.message);
                                return {}
                            }
                        },
                        function (response) {
                            errorHandler(response.message);
                            return {}
                        }
                    )
                },
                preloadedCategories: function (casinoCategoryService, pageStatuses, errorHandler) {
                    return casinoCategoryService.get({status: pageStatuses[0], parent_name: "AllCategories"}).then(
                        function (response) {
                            if (response.status === "ok") {
                                return angular.copy(response.categories)
                            } else {
                                errorHandler(response.message);
                                return {}
                            }
                        },
                        function (response) {
                            errorHandler(response.message);
                            return {}
                        }
                    )
                }
            }
        })
        .state('main.casinoGames.skinGameWinners', {
            abstract: true,
            url: "/winners",
            templateUrl: "views/winners/index.html",
            stateRef: "skinGameWinners",
            ncyBreadcrumb: {
                skip: true
            }
        })
        .state('main.casinoGames.skinGameWinners.list', {
            url: "/list",
            templateUrl: "views/winners/list.html",
            controller: "SkinGameWinnersPageController",
            stateRef: "skinGameWinners",
            ncyBreadcrumb: {
                label: 'breadcrumb.casinoGames.skinGameWinners.list'
            },
            resolve: {
                preloadedList: function (casinoGameService, errorHandler, pageStatuses, settingsService) {
                    var filters = {status: pageStatuses[0], limit: 25};
                    filters = angular.extend({}, filters, settingsService.getFilters());
                    return casinoGameService.getGameSkinWinners(filters).then(
                        function (response) {
                            if (response.status == "ok") {
                                return angular.copy(response);
                            } else {
                                errorHandler(response.message);
                                return []
                            }
                        },
                        function (response) {
                            errorHandler(response.message);
                            return []
                        }
                    )
                }
            }
        })
        .state('main.casinoGames.skinGameWinners.add', {
            url: "/add",
            templateUrl: "views/winners/add.html",
            controller: "AddEditSkinGameWinnersPageController",
            stateRef: "skinGameWinners",
            ncyBreadcrumb: {
                label: 'breadcrumb.casinoGames.skinGameWinners.add'
            },
            resolve: {
                preloadedSkinGames: function (casinoGameService, errorHandler) {

                    return casinoGameService.getSkinGamesPart({}).then(
                        function (response) {
                            if (response.status == "ok") {
                                return angular.copy(response.items);
                            } else {
                                errorHandler(response.message);
                                return []
                            }
                        },
                        function (response) {
                            errorHandler(response.message);
                            return []
                        }
                    )
                },
                preloadedWinnerData: function () {
                    return undefined
                }
            }
        })
        .state('main.casinoGames.skinGameWinners.edit', {
            url: "/:winnerId/edit",
            templateUrl: "views/winners/add.html",
            controller: "AddEditSkinGameWinnersPageController",
            stateRef: "skinGameWinners",
            ncyBreadcrumb: {
                label: 'breadcrumb.casinoGames.skinGameWinners.edit'
            },
            resolve: {
                preloadedSkinGames: function (casinoGameService, errorHandler) {

                    return casinoGameService.getSkinGamesPart({}).then(
                        function (response) {
                            if (response.status == "ok") {
                                return angular.copy(response.items);
                            } else {
                                errorHandler(response.message);
                                return []
                            }
                        },
                        function (response) {
                            errorHandler(response.message);
                            return []
                        }
                    )
                },
                preloadedWinnerData: function (casinoGameService, errorHandler, $stateParams) {
                    return casinoGameService.getGameSkinWinner({id: $stateParams.winnerId}).then(
                        function (response) {
                            if (response.status == "ok") {
                                return angular.copy(response.gameSkinWinner);
                            } else {
                                errorHandler(response.message);
                                return []
                            }
                        },
                        function (response) {
                            errorHandler(response.message);
                            return []
                        }
                    )
                }
            }
        })
        .state('main.hiddenGames', {
            url: "casinoGames/hiddenGames",
            templateUrl: "views/hiddenGames/list.html",
            stateRef: "hiddenGames",
            controller: "HiddenGamesListPageController",
            ncyBreadcrumb: {
                label: 'breadcrumb.hiddenGames.list'
            },
            resolve: {
                preloadedProviders: function (hiddenGamesService, errorHandler) {
                    return hiddenGamesService.getProviders().then(
                        function (response) {
                            if (response.status === "ok") {
                                delete response.status;
                                return angular.copy(response)
                            } else {
                                errorHandler(response.message);
                                return {}
                            }
                        },
                        function (response) {
                            errorHandler(response.message);
                            return {}
                        }
                    )
                },
                preloadedCategories: function (hiddenGamesService, errorHandler) {
                    return hiddenGamesService.getCategories().then(
                        function (response) {
                            if (response.status === "ok") {
                                delete response.status;
                                return angular.copy(response)
                            } else {
                                errorHandler(response.message);
                                return {}
                            }
                        },
                        function (response) {
                            errorHandler(response.message);
                            return {}
                        }
                    )
                }
            }
        })
        .state('main.topMatch', {
            abstract: true,
            url: "top",
            templateUrl: "views/pages/index.html",
            ncyBreadcrumb: {
                skip: true
            }
        })
        .state('main.topMatch.list', {
            "url": "-matches",
            templateUrl: "views/modules/list.html",
            controller: "TopMatchesPageController",
            ncyBreadcrumb: {
                label: 'breadcrumb.topMatches'
            },
            resolve: {
                preloadedData: function (topMatchesService, errorHandler) {
                    return topMatchesService.getList({limit: 25}).then(
                        function (response) {
                            if (response && response.status === "ok") {
                                return angular.copy(response);
                            } else {
                                errorHandler((response) ? response.message : "");
                                return null
                            }
                        },
                        function (response) {
                            errorHandler(response.message);
                            return null
                        }
                    )
                }
            }
        })
        .state('main.design', {
            abstract: true,
            url: "design/",
            templateUrl: "views/design/index.html",
            ncyBreadcrumb: {
                skip: true
            }
        })
        .state('main.design.customCss', {
            url: "custom-css",
            templateUrl: "views/design/customCss/index.html",
            controller: "CustomCssPageController",
            ncyBreadcrumb: {
                label: 'breadcrumb.customCSS'
            },
            resolve: {
                preloadedCSS: function (customCSSService, errorHandler) {
                    return customCSSService.loadCSS().then(
                        function (response) {
                            if (response.status === "ok") {
                                return angular.copy(response.data)
                            } else {
                                errorHandler(response.message);
                                return {}
                            }
                        },
                        function (response) {
                            errorHandler(response.message);
                            return {}
                        }
                    )
                }
            }
        })
        .state('main.design.mobileCustomCss', {
            url: "mobile-custom-css",
            templateUrl: "views/design/customCss/mobile.html",
            controller: "MobileCustomCssPageController",
            ncyBreadcrumb: {
                label: 'breadcrumb.mobileCustomCSS'
            },
            resolve: {
                preloadedCSS: function (customCSSService, errorHandler) {
                    return customCSSService.loadCSSMobile().then(
                        function (response) {
                            if (response.status === "ok") {
                                return angular.copy(response.data)
                            } else {
                                errorHandler(response.message);
                                return {}
                            }
                        },
                        function (response) {
                            errorHandler(response.message);
                            return {}
                        }
                    )
                }
            }
        })
        .state('main.design.logo', {
            url: "logo",
            templateUrl: "views/design/logo/logo.html",
            controller: "LogoPageController",
            ncyBreadcrumb: {
                skip: true
            },
            resolve: {
                preloadedLogos: function(settingsService, logoService, errorHandler){
                    return logoService.loadLogo().then(function (response) {
                            if (response.status === "ok") {
                                return angular.copy(response);
                            } else {
                                errorHandler(response.message);
                                return {}
                            }
                        },
                        function (response) {
                            errorHandler(response.message);
                            return {}
                        });
                }
            }
        })
        .state('main.pageBuilders', {
            abstract: true,
            url: "pageBuilders/",
            templateUrl: "views/pageBuilders/index.html",
            ncyBreadcrumb: {
                skip: true
            }
        })
        .state('main.pageBuilders.liveCasino', {
            url: "live-casino",
            templateUrl: "views/pageBuilders/liveCasino/liveCasinoView.html",
            controller: "LiveCasinoPageController",
            ncyBreadcrumb: {
                skip: 'breadcrumb.liveCasino'
            },
            resolve: {
                preloadedProviders: function (casinoProviderService, pageStatuses, errorHandler) {
                    return casinoProviderService.getSkinProviderByCategoryId({category: "28"}).then(
                        function (response) {
                            if (response.status === "ok") {
                                return angular.copy(response.items)
                            } else {
                                errorHandler(response.message);
                                return {}
                            }
                        },
                        function (response) {
                            errorHandler(response.message);
                            return {}
                        }
                    )
                },
                preloadedProperties: function(settingsService, liveCasinoService, $cookies, errorHandler){
                    var settings = settingsService.getSettings();
                    var request = {
                        lang: $cookies.get("preferedLanguage") || settings.skin.defaultLang
                    };
                    return liveCasinoService.load(request).then(function (response) {
                            if (response.status === "ok") {
                                return angular.copy(response);
                            } else {
                                errorHandler(response.message);
                                return {}
                            }
                        },
                        function (response) {
                            errorHandler(response.message);
                            return {}
                        });
                }
            }
        }).state('main.pageBuilders.skillGames', {
            url: "skill-games",
            templateUrl: "views/pageBuilders/skillGames/skillGamesView.html",
            controller: "SkillGamesPageController",
            ncyBreadcrumb: {
                skip: 'breadcrumb.skillGames'
            },
            resolve: {
                preloadedProperties: function(settingsService, skillGamesService, $cookies, errorHandler){
                    var settings = settingsService.getSettings();
                    var request = {
                        lang: $cookies.get("preferedLanguage") || settings.skin.defaultLang
                    };
                    return skillGamesService.load(request).then(function (response) {
                            if (response.status === "ok") {
                                return angular.copy(response);
                            } else {
                                errorHandler(response.message);
                                return {}
                            }
                        },
                        function (response) {
                            errorHandler(response.message);
                            return {}
                        });
                }
            }
    }).state('main.applications', {
            abstract: true,
            url: "applications/",
            templateUrl: "views/applications/index.html",
            ncyBreadcrumb: {
                skip: true
            }
       }) .state('main.applications.androidAppSkinning', {
            url: "android-app-skinning",
            templateUrl: "views/applications/androidAppSkinning/androidAppSkinning.html",
            controller: "AndroidAppSkinningController",
            ncyBreadcrumb: {
                label: 'breadcrumb.androidAppSkinning'
            },
            resolve: {
                preloadedData: function(androidAppService, errorHandler){
                    return androidAppService.loadData().then(function (response) {
                            if (response.status === "ok") {
                                return angular.copy(response.data);
                            } else {
                                errorHandler(response.message);
                                return {}
                            }
                        },
                        function (response) {
                            errorHandler(response.message);
                            return {}
                        });
                }

            }
    }).state('main.applications.androidAppSettings', {
        url: "android-app-settings",
        templateUrl: "views/applications/androidAppSettings/androidAppSettings.html",
        controller: "AndroidAppSettingsController",
        ncyBreadcrumb: {
            label: 'breadcrumb.androidAppSettings'
        },
        resolve: {}
    }).state('main.applications.iosAppSettings', {
        url: "ios-app-settings",
        templateUrl: "views/applications/iosAppSettings/iosAppSettings.html",
        controller: "IosAppSettingsController",
        ncyBreadcrumb: {
            label: 'breadcrumb.iosAppSettings'
        },
        resolve: {}
    }).state('main.applications.androidPromoApp', {
        url: "android-promo-app",
        templateUrl: "views/applications/androidPromoApp/androidPromoApp.html",
        controller: "AndroidPromoAppController",
        ncyBreadcrumb: {
            label: 'breadcrumb.androidPromoApp'
        },
        resolve: {
            preloadedPageNames: function ($rootScope, pagesService, settingsService, errorHandler, $cookies, Utils) {
                Utils.loadEnvFromStorage();
                var settings = settingsService.getSettings(),
                    filters = {
                        lang: $rootScope.env.lang || $cookies.get("preferedLanguage") || settings.skin.defaultLang,
                        pageType: "android_promo_app",
                        page_id: 0
                    };
                return pagesService.getPagesNames(filters).then(
                    function (response) {
                        return (angular.copy(response) || {});

                    },
                    function (error) {
                        errorHandler(error.message);
                        return null
                    }
                )
            },
            preloadedOptions: function( errorHandler, androidAppService) {
                return androidAppService.loadPromoOptions().then(function(optionsResponse){
                    return angular.copy(optionsResponse.data) || {};
                }, function (error) {
                    errorHandler(error.message);
                    return null
                })
            },
            preloadedData: function ($rootScope, $cookies,  settingsService, errorHandler, Utils, androidAppService) {
                Utils.loadEnvFromStorage();
                var settings = settingsService.getSettings();
                var filters = {
                    lang: $rootScope.env.lang || $cookies.get("preferedLanguage") || settings.skin.defaultLang,
                };
                return androidAppService.loadPromo(filters).then(
                    function (response) {
                        return response || {};
                    },
                    function (error) {
                        errorHandler(error.message);
                        return null
                    }
                )
            }
        }
    })
}).config(function ($breadcrumbProvider) {
    $breadcrumbProvider.setOptions({
        templateUrl: "views/breadcrumb/breadcrumbTemplate.html"
    });
}).config(['$httpProvider', function($httpProvider) {
    $httpProvider.defaults.timeout = 3600;
}]);


//angular-material#master
